/**
 * Live view of PHP-localized `window.rmlOpts`. Must not snapshot at module load.
 */ const { rmlOpts } = window;
export { rmlOpts };
